import { Component } from '@angular/core';
import { AccountItemsComponent } from 'libs/shared/src/lib/component/account-items/account-items.component';

@Component({ standalone: false, selector: 'app-account-items', templateUrl: './account-items.component.html' })
export class CustomAccountItemsComponent extends AccountItemsComponent {}
